module.exports = __webpack_public_path__ + "static/img/1000000501_red.301fa5e1.jpg";